import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { navLists } from '../constants';
import { NavBar } from './ui/tubelight-navbar.tsx';
import { Sparkles, Cpu, Box, Users, MessageCircle, Moon, Sun } from 'lucide-react';

import { useTheme } from './theme-provider';

const Navbar = () => {
  const [logo, setLogo] = useState(null);
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  useEffect(() => {
    const fetchBranding = async () => {
      try {
        const { data } = await api.get('/sections/Branding');
        if (data && data.content) {
          const contentMap = {};
          data.content.forEach(item => contentMap[item.key] = item.value);

          if (contentMap.logo) {
            const logoUrl = contentMap.logo.startsWith('http')
              ? contentMap.logo
              : `${import.meta.env.VITE_API_URL.replace('/api', '')}${contentMap.logo}`;
            setLogo(logoUrl);
          }
        }
      } catch (error) {
        console.error("Failed to fetch branding", error);
      }
    };
    fetchBranding();
  }, []);

  const iconMap = {
    "Highlights": Sparkles,
    "Services": Cpu,
    "Products": Box,
    "Meet Our Team": Users,
    "Contact Us": MessageCircle
  };

  const urlMap = {
    "Highlights": "#highlights",
    "Services": "#model",
    "Products": "#features",
    "Meet Our Team": "#team",
    "Contact Us": "#contact"
  };

  const navItems = navLists.map(name => ({
    name,
    url: urlMap[name] || `#${name.toLowerCase()}`,
    icon: iconMap[name] || Sparkles
  }));

  return (
    <NavBar
      items={navItems}
      leftElement={
        <a href="#hero" className="flex items-center gap-1 md:gap-2 hover:opacity-80 transition-opacity ml-0 md:ml-1">
          {logo ? (
            <img src={logo} alt="Logo" className="w-5 h-5 md:w-14 md:h-14 object-contain" />
          ) : (
            <span className="text-lg md:text-xl font-bold dark:text-white">SNC AI</span>
          )}
        </a>
      }
      rightElement={
        <button
          onClick={toggleTheme}
          className="p-1 md:p-2 rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition-colors text-black dark:text-white"
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
        </button>
      }
    />
  );
}

export default Navbar;